/* eslint-disable @typescript-eslint/no-explicit-any */
import { MultiSelect } from 'primereact/multiselect';
import React, { FC, useEffect, useState } from 'react';
import { MultiSelectDropDownProps, Options } from './Select.types';
import Checkbox from '../Checkbox/Checkbox';

const MultiSelectDropDown: FC<MultiSelectDropDownProps> = ({
  options,
  placeholder,
  maxSelectedLabels = 3,
  handleChange,
  initialSelectedOptions = [],
  name,
  setValue,
  selectDropDownStyle,
  errorStyle,
  helpText,
  className,
  label,
}) => {
  const [checked, setChecked] = useState<boolean>(false);
  const [selectedOptions, setSelectedOptions] = useState<Options[]>(
    initialSelectedOptions,
  );

  useEffect(() => {
    if (initialSelectedOptions.length > 0) {
      setSelectedOptions(initialSelectedOptions);
    }
  }, [initialSelectedOptions]);
  const handleMultiSelect = (option: Options[]) => {
    setSelectedOptions(option);
    handleChange && handleChange(option);
    setChecked(option.length > 0);

    if (name) {
      setValue && setValue(name, option, { shouldValidate: true });
    }
  };
  const itemTemplate = (option: Options) => {
    return (
      <div className={`${className} flex align-items-center pb-2`}>
        <div>{option.name}</div>
      </div>
    );
  };

  const headerTemplate = (option: {
    onCloseClick: React.MouseEventHandler<HTMLDivElement> | undefined;
  }) => {
    const allSelected = selectedOptions.length === options.length;

    return (
      <div className="flex flex-col mb-2">
        <div className="flex justify-between items-center px-2">
          <Checkbox
            checked={allSelected}
            onClick={() => {
              const newSelection = allSelected ? [] : options;
              setSelectedOptions(newSelection);
              handleChange && handleChange(newSelection);
              setChecked(!allSelected);

              if (name && setValue) {
                setValue(name, newSelection, { shouldValidate: true });
              }
            }}
          />
          <div className="cursor-pointer" onClick={option.onCloseClick}>
            <i className="pi pi-times text-primary pr-1" />
          </div>
        </div>
        <div className="h-[1px] w-full bg-slate-50"></div>
      </div>
    );
  };

  return (
    <div className="flex flex-col w-full">
      {label && <label className="text-white text-sm mb-2">{label}</label>}
      <MultiSelect
        value={selectedOptions}
        onChange={(e) => handleMultiSelect(e.value)}
        options={options}
        optionLabel="name"
        checked={checked}
        unstyled
        placeholder={placeholder}
        selectedItemsLabel={`${selectedOptions?.length} éléments selectionnés`}
        maxSelectedLabels={maxSelectedLabels}
        style={{ ...selectDropDownStyle, paddingLeft: '11px' }}
        checkboxIcon={
          <i className="pi pi-check text-mindGreen text-sm font-bold" />
        }
        className={`border-none flex items-center text-[13.8px]  justify-between bg-almostBlack px-4 relative rounded-[6px] min-h-12 flex-grow cursor-pointer ${selectedOptions?.length ? 'text-white' : 'text-[#939393]'}`}
        panelHeaderTemplate={headerTemplate}
        panelClassName="bg-almostBlack mt-[7px] border-none rounded-[4.93px] pt-2 pb-3 overflow-auto absolute"
        itemTemplate={itemTemplate}
        itemClassName="flex text-white pt-1 gap-2 px-2 mt-2"
      />
      {helpText && (
        <div className={`text-[12.8px] font-raleway pt-4 ${errorStyle}`}>
          {helpText}
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropDown;
